/* Crab Talk: only notify when the existing mixed-cart warning is present.
   Informational UI only; all current checkout/cart restrictions stay in force. */
(() => {
  if (window.crabTalkMixedCartHelpInstalled) return;
  window.crabTalkMixedCartHelpInstalled = true;

  const modalId = 'crabtalk-mixed-cart-help-dialog';
  const storageKey = 'crabtalk-mixed-cart-popup-last-shown';
  const cooldown = 10 * 60 * 1000;
  const whatsappURL = 'https://wa.me/6598398671?text=Hi%20Crab%20Talk%2C%20I%20would%20like%20to%20order%20a%20cooked%20crab%20bundle%20together%20with%20live%20or%20frozen%20seafood.%20Could%20you%20help%20with%20a%20special%20arrangement%3F';
  let scheduled = false;

  function readLastShown() {
    try { return Number(sessionStorage.getItem(storageKey) || 0); }
    catch (_) { return 0; }
  }

  function rememberShown() {
    try { sessionStorage.setItem(storageKey, String(Date.now())); }
    catch (_) { /* Storage may be disabled. */ }
  }

  function makeDialog() {
    const existing = document.getElementById(modalId);
    if (existing) return existing;

    const style = document.createElement('style');
    style.textContent = [
      '#' + modalId + ' {box-sizing:border-box;width:min(92vw,440px);max-height:calc(100dvh - 32px);margin:auto;border:1px solid #e2e6e8;border-radius:16px;padding:24px;background:#fff;color:#202b30;box-shadow:0 12px 50px #0003;font:inherit;}',
      '#' + modalId + '::backdrop {background:rgba(0,0,0,.56);}',
      '#' + modalId + ' h2 {font-size:1.3rem;line-height:1.3;margin:0 0 12px;font-weight:750;color:#142a32;}',
      '#' + modalId + ' p {font-size:.95rem;line-height:1.55;margin:0 0 12px;}',
      '#' + modalId + ' .ct-help-actions {display:flex;flex-wrap:wrap;gap:10px;margin-top:19px;}',
      '#' + modalId + ' .ct-help-actions a, #' + modalId + ' .ct-help-actions button {display:inline-flex;align-items:center;justify-content:center;min-height:44px;padding:11px 17px;border-radius:8px;font:inherit;font-weight:700;cursor:pointer;text-decoration:none;}',
      '#' + modalId + ' .ct-help-actions a {background:#16723d;color:#fff;border:1px solid #16723d;}',
      '#' + modalId + ' .ct-help-actions button {background:#fff;color:#233139;border:1px solid #bac6c9;}',
      '#' + modalId + ' .ct-help-fine-print {font-size:.84rem;color:#526066;}'
    ].join('\n');
    document.head.appendChild(style);

    const modal = document.createElement('dialog');
    modal.id = modalId;
    modal.setAttribute('aria-labelledby', 'ct-mixed-cart-help-title');
    modal.setAttribute('aria-describedby', 'ct-mixed-cart-help-text');
    modal.innerHTML =
      '<h2 id="ct-mixed-cart-help-title">Want to add other seafood to cooked crabs?</h2>' +
      '<p id="ct-mixed-cart-help-text">Cooked crab bundles must be checked out separately from live, frozen and other seafood. Our normal online checkout cannot combine them.</p>' +
      '<p>For a special request, WhatsApp us before placing your order. We will check whether a separate arrangement is possible.</p>' +
      '<p class="ct-help-fine-print">Special arrangements are subject to confirmation. Standard checkout restrictions remain unchanged.</p>' +
      '<div class="ct-help-actions"><a id="ct-mixed-cart-whatsapp" target="_blank" rel="noopener noreferrer">WhatsApp +65 9839 8671</a>' +
      '<button type="button" data-crabtalk-close-help>Keep orders separate</button></div>';
    modal.querySelector('#ct-mixed-cart-whatsapp').href = whatsappURL;
    modal.querySelector('[data-crabtalk-close-help]').addEventListener('click', () => modal.close());
    modal.addEventListener('click', (event) => {
      if (event.target === modal) modal.close();
    });
    document.body.appendChild(modal);
    return modal;
  }

  function openHelp(force) {
    // Never show this message when the cart is valid.
    if (!document.querySelector('.cart-separation-warning')) return;
    if (!force && Date.now() - readLastShown() < cooldown) return;
    const modal = makeDialog();
    if (modal.open) return;
    if (typeof modal.showModal !== 'function') return;
    try {
      modal.showModal();
      rememberShown();
    } catch (_) { /* Avoid interfering with the customer's cart. */ }
  }

  function scan() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      openHelp(false);
    });
  }

  document.addEventListener('click', (event) => {
    if (event.target instanceof Element && event.target.closest('[data-crabtalk-mixed-cart-help-open]')) {
      openHelp(true);
    }
  });

  function start() {
    new MutationObserver(scan).observe(document.body, {childList:true,subtree:true});
    scan();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();